import CommentThreadActions from './CommentThreadActions'

export default CommentThreadActions
// eslint-disable-next-line import/export
export * from './CommentThreadActions'
